import React, { useEffect, useState } from "react";
import { fetchChannelValues } from "../../../../services/reportsDataService";
import { styled, Typography } from "@mui/material";
import CompactCheckboxDropdown, {
  Option,
} from "./ReplEdititingFilters/CompactCheckboxDropdown";

interface ChannelFilterProps {
  value: string[];
  options: Option[];
  onChange: (value: string[]) => void;
  loading?: boolean;
}
interface Props {
  name: string;
  values: any;
  setValues: React.Dispatch<React.SetStateAction<any>>;
}

const ChannelFilter: React.FC<ChannelFilterProps> = ({
  value,
  options,
  onChange,
  loading,
}) => {
  return (
    <CompactCheckboxDropdown
      label="Select Outlet Channel"
      options={options}
      selectedValues={Array.isArray(value) ? value : []}
      onChange={onChange}
      placeholder="Select Outlet channel"
      width={235}
      loading={loading}
      enableSelectAll
      selectAllLabel="Select all channels"
    />
  );
};

const ChannelTypeFilter = (props: Props) => {
  const [channelOptions, setChannelOptions] = useState<any>([]);
  const [channelLoading, setChannelLoading] = useState<boolean>(false);
  const [filters, setFilters] = useState<any>({});
  const handleChannelChange = (values: string[]) => {
    setFilters((prev: any) => ({
      ...prev,
      channel: values,
    }));
    props.setValues({
      ...props.values,
      ["channel"]: {
        ...props.values?.["channel"],
        value: values,
      },
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      setChannelLoading(true);
      try {
        const res = await fetchChannelValues({
          report: "master_report_outlet",
          which: "channel",
          page: 1,
          pageSize: 100,
        });

        setChannelOptions(
          res?.map((item: string) => ({
            label: item,
            value: item,
          })) ?? []
        );
      } catch (err) {
        console.error("Error", err);
      } finally {
        setChannelLoading(false);
      }
    };
    fetchData();
  }, []);
  const Wrapper = styled("div")(`
    font-size:15px;
    text-align:left;
    padding-left:0.2rem;
    font-weight:500;
   margin-bottom: 8px;
    &::first-letter {
    text-transform: capitalize;
    }
  `);

  return (
    <>
      <Wrapper>
        Please Select the Outlet Channel
        <Typography
          component="span"
          sx={{ color: "red", ml: "4px", mr: "4px" }}
        >
          *
        </Typography>
      </Wrapper>
      <ChannelFilter
        value={filters?.channel ?? []}
        options={channelOptions}
        onChange={(values) => {
          handleChannelChange(values);
        }}
        loading={channelLoading}
      />
    </>
  );
};

export default ChannelTypeFilter;
